import type { CookieSetOptions } from 'universal-cookie'

const COOKIE_OPTIONS: CookieSetOptions = {
    path: `/`,
    sameSite: `strict`,
    secure: true
}

export { COOKIE_OPTIONS }
